import React from 'react'
import { ReviewTile, type IssueTrackingCTAMode, type SupplierLinkMode } from 'components/review_tiles/ReviewTile'
import type { Review } from 'components/supplier_show/prop_shapes/review'

interface ConversationReviewTileProps {
  review: Review | null
  issueTrackingCTAMode?: IssueTrackingCTAMode
  onActiveIssueClick?: () => void
  onIssueStatusChange?: () => void | Promise<void>
  supplierLinkMode?: SupplierLinkMode
}

export const ConversationReviewTile: React.FC<ConversationReviewTileProps> = ({
  review,
  issueTrackingCTAMode = 'hidden',
  onActiveIssueClick,
  onIssueStatusChange,
  supplierLinkMode
}) => {
  if (review == null) return null

  return (
    <div className='inbox-conversation-review-tile' data-testid='inbox-conversation-review-tile'>
      <ReviewTile
        review={review}
        displaySupplierName
        renderMode='messageReviewerModal'
        editActionMode='default'
        issueTrackingCTAMode={issueTrackingCTAMode}
        onActiveIssueClick={onActiveIssueClick}
        onIssueStatusChange={onIssueStatusChange}
        supplierLinkMode={supplierLinkMode}
      />
    </div>
  )
}
